import type { EmissorConfigType } from 'types';
import { env } from 'utils/env';

export const VRGPA: EmissorConfigType = {
  social: 'Grupo Pão de Açúcar',
  logo: `${env.REACT_APP_ASSETS_PORTAL}/vrgpa/img/logo-white.png`,
  infoList: [],
  portal: {},
  fonts: `${env.REACT_APP_ASSETS_PORTAL}/vrgpa/css/fonts.min.css`,
};
